import { useEffect, useState, forwardRef } from "react";
import { getUserNameArray } from "src/Common/function";
import BlueButton from "src/Components/Common/bluebutton";
import UserSelectModal from "../../Notification/components/userselectmodal";
import Recipients from "../components/recipients";
import DateInput from "./dateinput";
import DatePicker from "react-datepicker";
import { formatDate } from "src/Common/common";

const HoursWorked = ({ userArray, recipientIdList, setRecipientIdList, sendReport, isSending }) => {
  const [userSelectModalShown, setUserSelectModalShown] = useState(false);
  const [technicianNameList, setTechnicianNameList] = useState([]);

  const [past7Days, setPast7Days] = useState(false);
  const [past30Days, setPast30Days] = useState(false);
  const [customDays, setCustomDays] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const StartInput = forwardRef(({ value, onClick }, ref) => <DateInput text={value} onClick={onClick} />);
  const EndInput = forwardRef(({ value, onClick }, ref) => <DateInput text={value} onClick={onClick} />);

  useEffect(() => {
    if (recipientIdList.length === 0) {
      setTechnicianNameList("");
    }
  }, [recipientIdList]);

  const saveReport = (users) => {
    let recipientList = [];
    for (let user of users) {
      recipientList.push(String(user.id));
    }
    setRecipientIdList(recipientList);
    setTechnicianNameList(getUserNameArray(recipientList, userArray));
    setUserSelectModalShown(false);
  };

  return (
    <div className="w-full">
      <UserSelectModal
        shown={userSelectModalShown}
        userArray={userArray}
        selectedUserIdArray={recipientIdList}
        onCancel={() => setUserSelectModalShown(false)}
        onSave={(userArray) => saveReport(userArray)}
      />

      <div className="border-gray-100 border-[1px] rounded-md flex flex-col items-center justify-between w-[500px] gap-3 p-3 relative">
        <div className="w-full flex flex-col gap-3">
          <div className="font-OpenSansBold text-[16px] text-black h-[30px] flex items-center">Hours Worked</div>
        </div>

        <div className="w-full flex flex-col gap-3">
          <Recipients
            recipients={technicianNameList}
            onClick={() => {
              setUserSelectModalShown(true);
            }}
          />
        </div>
        <div className="w-full flex items-center gap-2 h-[26px]">
          <input
            type="checkbox"
            value={past7Days}
            onChange={(event) => {
              setPast7Days(event.target.checked);
            }}
          />
          <p className="font-OpenSansMedium text-[13px] text-black w-[80px]">Past 7 days</p>
        </div>

        <div className="w-full flex items-center gap-2 h-[26px]">
          <input type="checkbox" value={past30Days} onChange={(event) => setPast30Days(event.target.checked)} />
          <p className="font-OpenSansMedium text-[13px] text-black w-[80px] ">Past 30 days</p>
        </div>

        <div className="w-full flex items-center gap-2 h-[52px] ">
          <input type="checkbox" value={customDays} onChange={(event) => setCustomDays(event.target.checked)} />

          <div className="w-[120px] flex flex-col items-start">
            <p className="text-[12px] font-[600] text-start">Start Date</p>
            <DatePicker
              selected={startDate}
              onChange={(date) => {
                setStartDate(date);
              }}
              customInput={<StartInput />}
            />
          </div>

          <div className="w-[120px] flex flex-col items-start">
            <p className="text-[12px] font-[600] text-start">End Date</p>
            <DatePicker
              selected={endDate}
              onChange={(date) => {
                setEndDate(date);
              }}
              customInput={<EndInput />}
            />
          </div>
        </div>

        <div className="absolute right-3 bottom-20">
          <BlueButton
            title="Send Report Now"
            onClicked={() =>
              sendReport(
                past7Days,
                past30Days,
                customDays,
                formatDate(startDate, "MM/DD/YYYY"),
                formatDate(endDate, "MM/DD/YYYY")
              )
            }
            isLoading={isSending}
          />
        </div>
      </div>
    </div>
  );
};

export default HoursWorked;
